const clientSetPasswordMapper = (response) => {
    let result = { message: "", passwordReset: false };
    if (response && response.data.msg)
        return {
            message: response.data.msg,
            passwordReset: true,
        };
    return result;
};
export default clientSetPasswordMapper;
